import { PageRepository } from '@/context/global/api/repository/page';
import { TArtistDetailReq } from '@/context/global/types/getArtistDetail';
import { TPlaylistDetailFilter } from '@/context/global/types/playlist-detail';
import { TSearchFilter } from '@/context/global/types/search';
import { AxiosInstance } from 'axios';
import { TCategoryDetailFilter } from '@/context/global/types/category-detail';
import { withPagination } from '@/context/global/utils/pagination';

export const PageAPI = (axios: AxiosInstance): PageRepository => {
  return {
    GetHomeShelf(query) {
      return axios.get('/web/content/homeShelf', { params: query });
    },
    Playlist() {
      return axios.get('/web/content/page/listPlaylist');
    },
    PlaylistDetail(query: TPlaylistDetailFilter) {
      return axios.get('/web/content/playlist/detail', { params: withPagination(query) });
    },
    CategoryDetail(query: TCategoryDetailFilter) {
      return axios.get('/web/content/category/detail', { params: withPagination(query) });
    },
    Search(query: TSearchFilter) {
      return axios.get('/web/content/search', { params: withPagination(query) });
    },

    GetArtistDetail(query: TArtistDetailReq) {
      return axios.get('/web/content/artist/detail', { params: query });
    },
  };
};
